import React, { useEffect, useRef, useState } from 'react';
import { useParams, useLocation, useNavigate, Link } from 'react-router-dom'; // Adicione useLocation aqui
import { Container, Content, ContainerIframe, Back, ErrorMessage, ButtonProvider } from './styles';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

import { AppFirebase } from '../../config/firebase.js';
import { collection, doc, getDoc, getDocs, getFirestore } from 'firebase/firestore';
import Watch from '../watch/index.js';
import MovieInfoHeader from '../watch/movie-info-header/index.js';
import { saveOnWatching } from './save-on-watching/index.js';
import Episodes from './episodes';
import Collection from './collection/index.js';
import PopUpCheckWatched from './pop-up-mark-watched/index.js';
import MoreOptions from './more-options/index.js';
import PopUpDetails from './pop-up-details/index.js';
import Load from '../../components/load/index.js';

import providersIso from '../../components/providers-movies.js'
import { getTagName } from '../../components/get-category-name.js';
import AgeRating from '../../components/movie/age-rating/index.js';
import Cast from './cast/index.js';
import Suggestions from './suggestions/index.js';
import CollectionTv from './collection-tv/index.js';
import { verifyNewEpisodes } from './functions/index.js';
import { Swiper, SwiperSlide } from 'swiper/react';

export default function MovieDetails({ user, setBackgroundNav, movies }) {

    const { movieType, movieId, movieIdImdb } = useParams();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const watch = queryParams.get('watch');
    const season = queryParams.get('season');
    const episode = queryParams.get('episode');
    const detalhes = queryParams.get('detalhes');
    const outrosDetalhes = queryParams.get('outros-detalhes');
    const temporada = queryParams.get('temporada');
    const episodio = queryParams.get('episodio');

    const person = queryParams.get('pessoa');

    const [ labelMoviesSuggestions, setLabelMoviesSuggestions ] = useState('collection');

    const [loadingWatchData, setLoadingWatchData] = useState(true);
    const [movieData, setMovieData] = useState(null);
    const [movieDataDb, setMovieDataDb] = useState(null);
    const [watchData, setWatchData] = useState(null);
    const [watchDataWatching, setWatchDataWatching] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedSeason, setSelectedSeason] = useState(1);
    const [seasons, setSeasons] = useState(null);
    const [episodes, setEpisodes] = useState(null);
    const [seasonsWatching, setSeasonsWatching] = useState(null);
    const [episodesWatching, setEpisodesWatching] = useState(null);
    
    const [backgroundColor, setBackgroundColor] = useState(null);

    const [canShowPopUpCheckWatched, setCanShowPopUpCheckWatched] = useState(false);
    const [showPopUpCheckWatched, setShowPopUpCheckWatched] = useState(false);

    const database = getFirestore(AppFirebase);

    const navigate = useNavigate();
    
    const episodesRef = useRef(null);
    const episodeRefs = useRef({});

    const scrollToSection = (ref) => {
        ref.current.scrollIntoView({ behavior: 'smooth' });
    };

    useEffect(()=> {
        window.scrollTo(0,0);
        setSeasons();
        setLabelMoviesSuggestions('collection');

        console.log("all_movies: ", movies)
    }, [ movieType, movieId, movieIdImdb, movies ]);

    useEffect(()=> {

        console.log("watchDataWatching: ", watchDataWatching)
    }, [watchDataWatching ]);

    useEffect(() => {
        setLoading(true)
        const API_KEY = process.env.REACT_APP_TMDB_KEY;

        // Função para buscar detalhes do filme
        const fetchMovieDetails = async () => {
            try {
                const response = await fetch(`https://api.themoviedb.org/3/${movieType}/${movieId}?api_key=${API_KEY}&language=pt-BR`);
                const data = await response.json();
                if (response.ok) {
                    console.log("Fetch: api tmdb - ", obterDataHoraBR());
                    setMovieData(data);

                    fetchMovieData();

                } else {
                    setError('Erro ao buscar as informações.');
                }
            } catch (error) {
                setError('Erro de conexão com o TMDb.');
            } finally {
                setLoading(false);
            }
        };
        if (user?.uid && movieIdImdb) {
            fetchMovieDetails();
        }

    }, [movieType, movieId, movieIdImdb, user]);

    useEffect(() => {
        
        if (movieType == 'tv' && !detalhes && !seasons) {
            fetchSeasonData();
        }

    }, [detalhes, movieType, seasons, movieIdImdb]);

    useEffect(() => {
        if (watchData?.player && watch === 'true') {
            
            setCanShowPopUpCheckWatched(false);

            const timer = setTimeout(() => {
                setCanShowPopUpCheckWatched(true);
                defineAsWatched(watchData, 600);
                console.log("Salvando em assistidos...")
            }, 60000);
    
            return () => clearTimeout(timer);
        }
    }, [watchData, user, watch]);

    const defineAsWatched = (data, minutesWatched) => {
        const data_tv = { ...data, season_number: selectedSeason, id_tmdb: movieId, id_imdb: movieIdImdb, name: watchData?.name, media_type: watchData?.media_type};
        saveOnWatching(data?.media_type === 'tv' ? data_tv : data, minutesWatched, episodesWatching, setEpisodesWatching);
    };

    useEffect(()=> {
        if (!watchData?.src && !loadingWatchData && watch) {
            navigate(`/details/${movieType}/${movieId}/${movieIdImdb}`)
        }
    }, [ watchData, loadingWatchData ])

    useEffect(()=> {
        setBackgroundNav("#202020")
        document.querySelector('meta[name="theme-color"]').setAttribute('content', "#202020");

        if (!loading && !loadingWatchData) {
            
            if (movieDataDb?.background_color) {
                document.querySelector('meta[name="theme-color"]').setAttribute('content', `${movieDataDb?.background_color}`);
                setBackgroundNav(movieDataDb?.background_color ? `${movieDataDb?.background_color}` : "#202020")
                setBackgroundColor(movieDataDb?.background_color ? `${movieDataDb?.background_color}` : "#202020")
            }
            
        }

    }, [ movieDataDb, loading, loadingWatchData ]);

    // ocultar o scroll caso o componente 'watch' esteja sendo exibido
    useEffect(()=> {
        if (watch == 'true' || detalhes) {
            if (!loadingWatchData || person) {
                document.body.style.overflow = 'hidden';
            }
        } else if (!person) {
            document.body.style.overflow = 'auto';
        }
    }, [ watch, loadingWatchData, detalhes ])

    useEffect(()=> {
        if (movieData) {
            document.title = `${movieData?.name ? movieData?.name : movieData?.title} - Moov PRO`
        }
    }, [ movieData ]);

    const fetchMovieData = async () => {

        setLoadingWatchData(true);

        try {
            const movieRef = doc(database, `watch/${movieIdImdb}/`);
            const movieSnap = await getDoc(movieRef);
            
            console.log(`Fetch: "watch/${movieIdImdb}/" - `, obterDataHoraBR());

            if (movieSnap.exists()) {
                setWatchData(movieSnap.data());
                setMovieDataDb(movieSnap.data());
                console.log(setMovieDataDb(movieSnap.data()));
            } else {
                navigate('/');
                alert("Ocorreu um erro. tente novamente!");
            }
        } catch (error) {
            console.log('Erro ao buscar dados do filme:', error);
        } finally {
            setTimeout(()=>{
                setLoadingWatchData(false);
            }, 1000)
        }
    };

    const fetchSeasonData = async () => {

        try {
            const seasonRef = collection(database, `watch/${movieIdImdb}/seasons`);
            const seasonSnap = await getDocs(seasonRef);
            console.log(`Fetch: "watch/${movieIdImdb}/seasons" - `, obterDataHoraBR());
            let seasons = seasonSnap.docs.map(doc => doc.data());
            
            setSeasons(seasons);
            fetchSeasonDataWatching();
        } catch (error) {
            console.log('Erro ao buscar dados da temporada:', error);
        } finally {
            setTimeout(()=>{
                setLoadingWatchData(false);
            }, 1000)
        }
    };
/*
    const fetchMovieDataWatching = async () => {

        const profileUid = localStorage.getItem("profile_uid");

        try {
            const movieRef = doc(database, `profiles/${profileUid}/playlists/watching/movies/${movieIdImdb}`);
            const movieSnap = Rawait getDoc(movieRef);
            
            if (movieSnap.exists()) {
                setMovieDataWatching(movieSnap.data())
            }
        } catch (error) {
            console.log('Erro ao buscar dados da temporada:', error);
        } finally {
            console.log("Verificou se o usuario está assistindo este filme")
        }
    };

*/
        
    const fetchSeasonDataWatching = async () => {
        const profileUid = localStorage.getItem("profile_uid");

        try {
            const seasonRef = collection(database, `profiles/${profileUid}/playlists/watching/movies/${movieIdImdb}/seasons`);
            const seasonSnap = await getDocs(seasonRef);
            console.log(`Fetch: "pr***/pro****_**id/pl****sts/watching/movies/${movieIdImdb}/s*****" - `, obterDataHoraBR());
            
            // Mapeia os dados das temporadas
            let seasons = seasonSnap.docs.map(doc => doc.data());

            // Ordena as temporadas pela propriedade season_number
            seasons.sort((a, b) => b.updated - a.updated);

            setSeasonsWatching(seasons);
            
            // Defina a primeira temporada como a selecionada
            if (seasons?.length > 0) {
                setSelectedSeason(seasons[0]?.season_number);
                setEpisodesWatching(seasons[0]?.episodes);
            }
        } catch (error) {
            console.log('Erro ao buscar dados da temporada:', error);
        } finally {
            console.log("Verificou se o usuário está assistindo essa série");
        }
    };

    useEffect(() => {

        if (seasons?.length === 1) {
            
            setSelectedSeason(seasons[0]?.season_number);

            if (seasonsWatching?.length == 1) {
                setEpisodesWatching(seasonsWatching[0]?.episodes);
                console.log("Episodes watching: ", seasonsWatching[0]?.episodes);
            }

            const season = seasons[0];

            if (season) {
                // Ordena os episódios pelo "episode_details?.episode_number"
                const orderedEpisodes = season.episodes.sort((a, b) => {
                    const episodeNumberA = a.episode_details?.episode_number;
                    const episodeNumberB = b.episode_details?.episode_number;
                    return episodeNumberA - episodeNumberB;
                });
    
                setEpisodes(orderedEpisodes);
            }
        }

        if (seasons?.length > 1) {
            
            // Encontra a temporada correspondente ao "selectedSeason"
            const selectedSeasonObj = seasons?.find(season => season?.season_number == selectedSeason);
            const selectedSeasonWatchingObj = seasonsWatching?.find(season => season?.season_number == selectedSeason);

            if (selectedSeasonWatchingObj?.episodes?.length > 0) {
                setEpisodesWatching(selectedSeasonWatchingObj?.episodes);
                console.log("Episodios sendo assistidos: ", selectedSeasonWatchingObj?.episodes);
            } else {
                setEpisodesWatching(null);
                console.log("Não há episodios assistidos nesta temporada");
            }

            if (selectedSeasonObj) {
                // Ordena os episódios pelo "episode_details?.episode_number"
                const orderedEpisodes = selectedSeasonObj.episodes.sort((a, b) => {
                    const episodeNumberA = a.episode_details?.episode_number;
                    const episodeNumberB = b.episode_details?.episode_number;
                    return episodeNumberA - episodeNumberB;
                });
    
                setEpisodes(orderedEpisodes);
            }
        }

        console.log("Temporada atual: ", selectedSeason)
    }, [seasons, selectedSeason, movieIdImdb]);

    const handleSeasonChange = (seasonNumber) => {
        setSelectedSeason(seasonNumber);
    };

    const mesesPT = ['Jan', 'Fev', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

    function verificarLancamento(e) {
        const lancamento = e;
        const dateLancamento = new Date(lancamento);
        const timestampLancamento = Math.floor(dateLancamento.getTime() / 1000);

        var date = new Date();
        var dataHoje = date.getFullYear() + '-' + (date.getMonth()+1) + "-" + date.getDate();
        var dataLancamento = new Date(dataHoje);
        const timestampDataHoje = Math.floor(dataLancamento.getTime() / 1000);

        return timestampDataHoje > timestampLancamento;
    }

    const converter = (minutos) => {
        const horas = Math.floor(minutos / 60);
        const min = minutos % 60;
        const textoHoras = `${horas}`;
        const textoMinutos = `${min}`;

        if (minutos <= 59) {
            return `${textoMinutos}min`;
        } else if (minutos == 60) {
            return `${textoHoras}h`;
        } else if (minutos >= 61) {
            return `${textoHoras}h, ${textoMinutos}min`;
        }
    };
    
    function dataConvert(data) {
        const dataObj = new Date(data);
        const mes = dataObj.getMonth();
        return `${dataObj.getDate() + 1} de ${mesesPT[mes]} de ${dataObj.getFullYear()}`;
    }

    function obterDataHoraBR() {
        const dataAtual = new Date();
    
        // Data
        const dia = String(dataAtual.getDate()).padStart(2, '0');
        const mes = String(dataAtual.getMonth() + 1).padStart(2, '0'); // Mês começa do 0
        const ano = dataAtual.getFullYear();
    
        // Hora
        const horas = String(dataAtual.getHours()).padStart(2, '0');
        const minutos = String(dataAtual.getMinutes()).padStart(2, '0');
        const segundos = String(dataAtual.getSeconds()).padStart(2, '0');
    
        // Formato final
        return `${dia}/${mes}/${ano} ${horas}:${minutos}:${segundos}`;
    }

    const openPopUpWatched = ()=> {
        if (movieType == 'movie') {
            navigate(`/details/${movieType}/${movieId}/${movieIdImdb}`)
        } else {
            const dontShowPopUp = localStorage.getItem("dont_show_again_mark_episode_as_watched");

            if (!dontShowPopUp) {
                setShowPopUpCheckWatched(true);
            }
        }
    }

    if (loading || loadingWatchData) {
        return <Container><Load align_center={true}/></Container>;
    }

    if (error) {
        return <Container>{error}</Container>;
    }

    const lastEpisodeWatched = episodesWatching?.length > 0
    ? episodesWatching.reduce((latest, current) => {
        return current.updated > (latest?.updated || 0) ? current : latest;
    }, null)
    : null;

    const handleContinueWatching = (e) => {
        e.preventDefault();
        
        if (lastEpisodeWatched && episodeRefs.current[lastEpisodeWatched.episode_id]) {
            episodeRefs.current[lastEpisodeWatched.episode_id]?.click();
        }
    };

    return (
        <Container background_color={movieDataDb?.background_color || "transparent"}>
            {movieDataDb?.background_color &&
                <div className='image-background' style={{backgroundImage: `url(https://image.tmdb.org/t/p/original${movieDataDb?.background_path ? movieDataDb?.background_path : movieData?.backdrop_path})`}}></div>
            }
            {movieData &&
                <Content background_color={movieDataDb?.background_color}>
                    <img
                        className='main-image'
                        src={`https://image.tmdb.org/t/p/original${movieDataDb?.background_path ? movieDataDb?.background_path : movieData?.backdrop_path}`}
                        alt={movieData?.title || movieData?.name}
                    />
                    {!movieDataDb?.can_watch_on?.includes('web') &&
                        <ErrorMessage background={'#f00'} margin={'10px 0 -10px 0'}>
                            <p><i className='fas fa-triangle-exclamation'></i> {movieType == 'tv' ? 'Esta série' : 'Este filme'} está disponível apenas no aplicativo!</p>
                        </ErrorMessage>
                    }
                    <div className='header-details-movie'>
                        {movieData && seasons && (movieDataDb?.media_type == 'tv' && verifyNewEpisodes(movieData?.seasons[movieData?.seasons?.length - 1]?.air_date, movieData?.seasons[movieData?.seasons?.length - 1]?.season_number, seasons[seasons?.length - 1]?.season_number)) &&
                            <span className="span-new-episodes"><i className="fas fa-info-circle"></i> Novos episódios</span>
                        }
                        <h1 className="titulo-movie-assistir">{movieData?.title || movieData?.name}</h1>
                        <footer>
                            {(movieDataDb?.can_watch_on?.includes('web') && movieType == 'movie') &&
                                <Link className="link-watch" to={`?watch=true`}>
                                    <i className="fas fa-play"></i> <small>Assistir</small>
                                </Link>
                            }
                            {(movieDataDb?.can_watch_on?.includes('web') && movieType == 'tv') &&
                                <Link className="link-watch" onClick={(e) => episodesWatching?.length > 0 ? handleContinueWatching(e) :  scrollToSection(episodesRef)}>
                                    <i className="fas fa-play"></i> <small>{(episodesWatching?.length > 0) ? "Continuar" : "Assistir"}</small>
                                </Link>
                            }
                            {(movieDataDb?.link_to_movie_provider && movieDataDb?.providers[0] != 1001) &&
                                <ButtonProvider background_color={providersIso[movieDataDb?.providers[0]]?.background_color} text_color={providersIso[movieDataDb?.providers[0]]?.text_color} href={movieDataDb?.link_to_movie_provider} target='_blank'>
                                    <img src={providersIso[movieDataDb?.providers[0]]?.image_path}/> <small>{providersIso[movieDataDb?.providers[0]]?.show_name != false ? providersIso[movieDataDb?.providers[0]]?.name : null}</small>
                                </ButtonProvider>
                            }
                        </footer>
                    </div>
                <div className="movie-details">
                    {/*verifica a data de novas temporadas */}
                    {/*(movieType == 'tv') &&
                        <>
                            {!verificarLancamento(movieData?.seasons[movieData?.seasons?.length - 1]?.air_date) &&
                                <span className="span-lancamento-nova-temporada">{movieData?.seasons[movieData?.seasons.length - 1]?.name} em {(movieData?.seasons[movieData?.seasons.length - 1]?.air_date).slice("8", "10")} de {mesesPT[Number((movieData?.seasons[movieData?.seasons.length - 1]?.air_date).slice("5", "7") - 1)]} </span>
                            }
                        </>
                    */}
                    {(movieType == 'movie') &&
                        <>
                            {(!verificarLancamento(movieData?.release_date) && (movieData?.release_date && (Number((movieData?.release_date).slice("0", "4")) == 2023))) &&
                                <span className="span-lancamento-nova-temporada">Disponível em {(movieData?.release_date).slice("8", "10")} de {mesesPT[Number((movieData?.release_date).slice("5", "7") - 1)]}</span>
                            }
                        </>
                    }
                    <Swiper className="informacoes-movie-assistir">
                        <SwiperSlide>
                            <span className="span-assistir-filmes-series">{movieType === 'movie' ? 'Filme' : 'Série'}</span>
                        </SwiperSlide>
                        <SwiperSlide>
                            {(movieData?.first_air_date || movieData?.release_date) &&
                                <section>
                                    <Tippy content={dataConvert(movieData?.release_date ? movieData?.release_date : movieData?.first_air_date)}>
                                        <section>
                                            {movieData?.first_air_date &&
                                                <span>{movieData?.first_air_date.slice(0,4)}</span>
                                            }
                                            {movieData?.release_date &&
                                                <span>{movieData?.release_date.slice(0,4)}</span>
                                            }
                                        </section>
                                    </Tippy>
                                </section>
                            }
                        </SwiperSlide>
                        <SwiperSlide>
                            {movieData?.vote_count > 0 &&
                                <section>
                                    <Tippy content={'Avaliações'}>
                                        <section>
                                            <span><i className="fas fa-star"></i> {movieData?.vote_average && (movieData?.vote_average).toFixed(1)}<small>/10</small></span>
                                        </section>
                                    </Tippy>
                                </section>
                            }
                        </SwiperSlide>
                        <SwiperSlide>
                            {movieDataDb?.age_rating?.age &&
                                <AgeRating linkRedirect={`/details/${movieType}/${movieId}/${movieIdImdb}?detalhes=outras-informacoes`} age_rating={movieDataDb?.age_rating?.age[0]}/>
                            }
                        </SwiperSlide>
                        <SwiperSlide>
                            {(movieData?.runtime > 0) &&
                                <section>
                                    <Tippy content={`Duração: ${converter(movieData?.runtime)}`}>
                                        <section className="lancamento-movie-assistir">
                                            <span className="duracao-movie-assistir"><i className="fa-regular fa-clock"></i> {converter(movieData?.runtime)}</span>
                                        </section>
                                    </Tippy>
                                </section>
                            }
                        </SwiperSlide>
                        <SwiperSlide>
                            {(movieType == 'tv' && movieData?.number_of_seasons) &&
                                <section>
                                    <Tippy content={`${movieData?.number_of_seasons} Temporadas e ${movieData?.number_of_episodes} Episódios`}>
                                        <section className="section-temporadas">
                                            <span>{movieData?.number_of_seasons}T</span>
                                            <span>. | {movieData?.number_of_episodes} EP's.</span>
                                        </section>
                                    </Tippy>
                                </section>
                            }
                        </SwiperSlide>
                        <SwiperSlide>
                            {movieData?.episode_run_time && movieData?.episode_run_time?.length == 1 && 
                                <section>
                                    <Tippy content={`Duração: ${converter(movieData?.episode_run_time)} (Por episódio)`}>
                                        <section className="lancamento-movie-assistir">
                                            <span className="duracao-movie-assistir"><i className="fa-regular fa-clock"></i> {converter(movieData?.episode_run_time)}</span>
                                        </section>
                                    </Tippy>
                                </section>
                            }
                        </SwiperSlide>
                    </Swiper>
                    {movieData?.overview &&
                        <p className="descricao-movie-assistir">{movieData?.overview}</p>
                    }
                    <div className='container-tags'>
                        {movieDataDb?.tags?.map((tag, key) => {
                            const tagsToIgnore = [47, 48, 49, 50];

                            // Verificar se a tag está na lista de tags a ignorar
                            if (tagsToIgnore.includes(tag)) {
                                return null; // Ignorar a tag
                            }

                            return (
                                <span key={key}>{getTagName(tag)}</span>
                            );
                        })}
                    </div>
                    {movieDataDb?.cast &&
                        <Cast cast={movieDataDb?.cast} movie_type={movieDataDb?.media_type}/>
                    }
                    {(seasons && movieType == 'tv' && (movieDataDb?.can_watch_on?.includes('web'))) &&
                        <Episodes 
                            movie={movieData} 
                            movie_id={movieId} 
                            movie_id_imdb={movieIdImdb} 
                            movie_season={selectedSeason}
                            episodes_watching={episodesWatching}
                            setEpisodesWatching={setEpisodesWatching}
                            defineAsWatched={defineAsWatched}
                            setWatchData={setWatchData}
                            setWatchDataWatching={setWatchDataWatching}
                            seasons={seasons}
                            episodes={episodes}
                            setEpisodes={setEpisodes}
                            handleSeasonChange={handleSeasonChange}
                            episodesRef={episodesRef}
                            episodeRefs={episodeRefs}
                        />
                    }
                    {(movieDataDb?.movie_collection_id || (movieDataDb?.media_type == 'tv' && movieDataDb?.movie_subcollection_id)) &&
                        <div className='div-label-movies'>
                            <button onClick={()=>setLabelMoviesSuggestions('collection')} className={labelMoviesSuggestions == 'collection' ? 'active' : ''}>Coleção</button>
                            <button onClick={()=>setLabelMoviesSuggestions('suggestions')} className={labelMoviesSuggestions == 'suggestions' ? 'active' : ''}>Sugestões</button>
                        </div>
                    }
                    {labelMoviesSuggestions == 'collection' && (movieType == 'movie' && watchData?.movie_collection_id) &&
                        <Collection movie={watchData} all_movies={movies}/>
                    }
                    {labelMoviesSuggestions == 'collection' && (movieType == 'tv' && watchData?.movie_subcollection_id) &&
                        <CollectionTv movie={watchData} all_movies={movies}/>
                    }
                    {(labelMoviesSuggestions == 'suggestions' || (!watchData?.movie_collection_id && !watchData?.movie_subcollection_id)) &&
                        <Suggestions movie={watchData} all_movies={movies}/>
                    }
                    <MoreOptions media_type={movieType} imdb_id={movieIdImdb} backgroundColor={backgroundColor}/>
                </div>
            </Content>
            }
            {!loadingWatchData && watch == 'true' &&
                <>
                    <Back onClick={()=>openPopUpWatched()}><i className='fas fa-chevron-left'></i></Back>
                    {watchData && watchData?.player == 'moov' &&
                        <Watch movieData={movieData} movie_type={movieType} movie_id={movieId} movie_id_imdb={movieIdImdb} season={season} episode={episode} episodes={episodes} setWatchData={setWatchData} watch_data={watchData} watch_data_watching={watchDataWatching}/>
                    }
                    
                    {watchData && watchData?.player == 'iframe' &&
                        <ContainerIframe>
                            <MovieInfoHeader movie_data={movieData} watch_data={watchData}/>
                            <iframe frameBorder={0} allowFullScreen={true} src={watchData?.src}></iframe>
                        </ContainerIframe>
                    }
                </>
            }
            {canShowPopUpCheckWatched && showPopUpCheckWatched &&
                <PopUpCheckWatched setShowPopUpCheckWatched={setShowPopUpCheckWatched} background_color={movieDataDb?.background_color} defineAsWatched={defineAsWatched} watchData={watchData} navigate={navigate} url={`/details/${movieType}/${movieId}/${movieIdImdb}`}/>
            }
            {detalhes &&
                <PopUpDetails movie_data={movieData} movie_data_db={movieDataDb} tab={detalhes} temporada={temporada} episodio={episodio} linkBack={`/details/${movieType}/${movieId}/${movieIdImdb}`} media_type={movieType} movie_id={movieId} movie_id_imdb={movieIdImdb} background_color={movieDataDb?.background_color || "#303030"} />
            }
            </Container>
    );
}